import * as actionTypes from '../actions/actionTypes/approvalTypes';

export interface IApprovalReducer {
    isApprovalOverviewLocked: boolean;
}

const defaultState = (): IApprovalReducer => ({
    isApprovalOverviewLocked: false
});

export default (state = defaultState(), action): IApprovalReducer => {
    switch (action.type) {
        case actionTypes.LOCK_APPROVAL_OVERVIEW: {
            return {
                ...state,
                isApprovalOverviewLocked: true
            };
        }
        case actionTypes.UNLOCK_APPROVAL_OVERVIEW: {
            return {
                ...state,
                isApprovalOverviewLocked: false
            };
        }
        default: {
            return state;
        }
    }
};
